<template>
  <a-card :bordered="false">
    <div>
      <a-spin :spinning="loading">
        <a-form :form="form" :layout="formLayout">
          <a-row>
            <a-col :span="24">
              <a-divider orientation="left">
                基础信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="系统编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="系统编号" disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['contract_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="合同号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input allow-clear placeholder="合同名称" v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="贸易类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  allow-clear
                  v-decorator="[
                    'trade_type',
                    {
                      rules: [
                        { required: true, message: '' },
                      ],
                    },
                  ]"
                  placeholder="选择"
                  :default-active-first-option="false"
                  @change="handleTradeTypeChange"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in tradeTypes">
                    {{ val }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="签订日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['contract_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="签订日期"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="data['type'] === 1 ? '供应商':'客户'" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  mode="multiple"
                  option-label-prop="tt"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  v-decorator="[
                    'client_ids',
                    {
                      rules: [
                        { required: true, message: '选择客户' },
                      ],
                    },
                  ]"
                  placeholder="请输入客户"
                  :default-active-first-option="false"
                  @search="this.clientSearch"
                >
                  <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                    {{ d.client }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="产品名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['product_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="产品名称" @change="productNameChange" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number placeholder="数量" allow-clear :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" v-decorator="['count', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                  <template slot="addonAfter">
                    <a-button type="primary">操作</a-button>
                  </template>
                </a-input-number>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="数量单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  style="width: 100%"
                  placeholder="选择"
                  show-search
                  :filter-option="filterOption"
                  :not-found-content="null"
                  :default-active-first-option="false"
                  v-decorator="['unit', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit" :label="val">
                    {{ val }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="tradeType !== 1">
              <a-form-item label="贸易术语" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  v-decorator="[
                    'trade_term',
                    {
                      rules: [
                        { required: true, message: '请选择贸易术语' },
                      ]
                    },
                  ]"
                  show-search
                  :filter-option="filterOption"
                  placeholder="选择"
                >
                  <a-select-option
                    v-for="(val) in this.$Dictionaries.trade_terms"
                    :value="val"
                    :key="val">
                    {{ val }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货地" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['delivery_address', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="交货地"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="最迟交货日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['latest_delivery_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="最迟交货日期"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="溢装率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number allow-clear v-decorator="['overloading_rate', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]"/> %
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="短装率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number allow-clear v-decorator="['shortage_rate', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]"/> %
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                财务信息
              </a-divider>
            </a-col>
            <a-col :span="12" v-if="data && data['type'] === 1">
              <a-form-item label="关税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number style="width: 20%" allow-clear v-decorator="['tariff', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                <a-select
                  style="width: 20%"
                  v-decorator="['tariff_type', { rules: [{required: false, message: '请选择' }]}]"
                  placeholder="选择"
                  allow-clear
                  option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_tax_type">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data && data['type'] === 1">
              <a-form-item label="消费税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number style="width: 20%" allow-clear v-decorator="['consumption_tax', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                <a-select
                  style="width: 20%"
                  v-decorator="['consumption_tax_type', { rules: [{required: false, message: '请选择' }]}]"
                  placeholder="选择"
                  allow-clear
                  option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_tax_type">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data && data['type'] !== undefined">
              <a-form-item label="增值税率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number style="width: 20%" allow-clear v-decorator="['tax_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/> %
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                商品信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="规格型号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['spec', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="规格型号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="tradeType !== 1">
              <a-form-item label="HSCode" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['customs_declaration_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="HSCode"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="质量" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-button icon="plus" style="margin-left: 10px" @click="addProductParameter(otherData.product_parameters)">产品参数</a-button>
              </a-form-item>
            </a-col>
            <a-col :offset="2" :span="20" v-if="otherData.product_parameters.length > 0">
              <a-table
                bordered
                :data-source="otherData.product_parameters"
                :columns="parameterColumns"
                v-if="this.otherData.product_parameters.length > 0"
                :pagination="false"
                key="key">
                <span slot="serial" slot-scope="text, record, index">
                  {{ index + 1 }}
                </span>
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.product_parameters.length"
                    title="确定删除?"
                    @confirm="() => onParameterDelete(record.id)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-col>
            <a-col :span="12">
              <a-form-item label="质量扣款依据" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-textarea v-decorator="['quality_deduction_reason', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="质量扣款依据" :rows="2"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                金额信息
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="定价方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-select
                  v-decorator="[
                    'unit_price_type',
                    {
                      rules: [
                        { required: false, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  allow-clear
                  @change="unitPriceChange"
                  option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit_price_type">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 1">
              <a-divider orientation="left" dashed>固定定价</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-select
                      v-decorator="[
                        'pricing_currency',
                        {
                          rules: [
                            { required: false, message: '请选择' }
                          ],
                        },
                      ]"
                      placeholder="选择"
                      show-search
                      @change="pricingCurrencyChange"
                      option-filter-prop="children"
                      :filter-option="filterOption">
                      <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="收款币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-select
                      v-decorator="[
                        'receive_pricing_currency',
                        {
                          rules: [
                            { required: false, message: '请选择' }
                          ],
                        },
                      ]"
                      placeholder="选择"
                      show-search
                      @change="receivedPricingCurrencyChange"
                      option-filter-prop="children"
                      :filter-option="filterOption">
                      <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number style="width: 50%" allow-clear v-decorator="['unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="单价"/>
                    <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="单价是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_unit_price', {valuePropName: 'checked', rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number style="width: 50%" allow-clear v-decorator="['exchange_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="汇率"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number
                      style="width: 50%"
                      allow-clear
                      placeholder="数量"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      v-decorator="['pricing_count', {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number
                      style="width: 50%"
                      allow-clear
                      placeholder="合同金额"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      v-decorator="['contract_amount', { rules: [{required: false, message: '必填项，请填写信息'}]}]" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_contract_amount', {valuePropName: 'checked', rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 2">
              <a-divider orientation="left" dashed>点价定价</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-select
                      v-decorator="[
                        'pricing_currency',
                        {
                          rules: [
                            { required: false, message: '请选择' }
                          ],
                        },
                      ]"
                      placeholder="选择"
                      show-search
                      @change="pricingCurrencyChange"
                      option-filter-prop="children"
                      :filter-option="filterOption">
                      <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="收款币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-select
                      v-decorator="[
                        'receive_pricing_currency',
                        {
                          rules: [
                            { required: false, message: '请选择' }
                          ],
                        },
                      ]"
                      placeholder="选择"
                      show-search
                      @change="receivedPricingCurrencyChange"
                      option-filter-prop="children"
                      :filter-option="filterOption">
                      <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="升贴水" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number allow-clear v-decorator="['premium_discount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="升贴水"/>
                    <span style="padding-left: 10px">正数为升水、负数为贴水</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="点价费" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number allow-clear v-decorator="['price_fixing_fee', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="点价费"/>
                    <span style="padding-left: 5px" v-if="false">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="定价源" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input allow-clear v-decorator="['pricing_source', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="定价源，例如：ICE布伦特"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="期货合约" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-month-picker
                      v-decorator="['futures_contract', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                      format="YYYY-MM"
                      value-format="yyyy-MM-DD"
                      placeholder="期货合约"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="目前锁价期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-date-picker
                      v-decorator="['lock_up_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                      format="YYYY-MM-DD"
                      placeholder="锁价期限"
                      value-format="yyyy-MM-DD"
                    />
                    <span style="padding-left: 5px">备注：不包含当天</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="默认计价期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-range-picker
                      @change="time"
                      format="YYYY-MM-DD"
                      style="width: 100%"
                      v-decorator="['pricing_period', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                      <template slot="dateRender" slot-scope="current">
                        <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                          {{ current.date() }}
                        </div>
                      </template>
                    </a-range-picker>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-row>
                    <a-col :span="12">
                      <a-form-item label="是否可转月" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                        <a-switch checked-children="是" un-checked-children="否" v-model="isTurningMonth"/>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item v-if="isTurningMonth" label="转月费" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                        <a-input-number allow-clear v-decorator="['monthly_transfer_fee', {rules: [{required: isTurningMonth, message: '必填项，请填写信息'}]}]" placeholder="转月费"/>
                        <span style="padding-left: 5px" v-if="false">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                      </a-form-item>
                    </a-col>
                    <a-col :offset="2" :span="22" v-if="otherData.turning_month_list.length > 0 || isTurningMonth">
                      <a-table
                        style="width: 80%"
                        :data-source="otherData.turning_month_list"
                        ref="turningMonthTable"
                        :columns="turningMonthColumns"
                        :pagination="false">
                        <span slot="serial" slot-scope="text, record, index">
                          {{ index + 1 }}
                        </span>
                        <template slot="action" slot-scope="text, record">
                          <a-popconfirm
                            title="确定删除吗?"
                            @confirm="() => onDeleteItem(record.key)"
                          >
                            <a href="javascript:;">删除</a>
                          </a-popconfirm>
                        </template>
                        <template slot="footer">
                          <div style="text-align: center">
                            <a-button @click="addTurningMonth(true)" icon="plus">转月</a-button>
                          </div>
                        </template>
                      </a-table>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="汇率" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                    <a-select
                      style="width: 20%"
                      v-decorator="[
                        'exchange_rate_type',
                        {
                          rules: [
                            { required: true, message: '请选择' }
                          ],
                        },
                      ]"
                      placeholder="选择"
                      allow-clear
                      @change="exchangeRateChange"
                      option-filter-prop="children"
                      :filter-option="filterOption">
                      <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.exchange_rate">{{ val }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24" v-if="selectedExchangeRate > 0">
                  <!--                  <a-divider orientation="left" dashed>{{ exchangeRateTitle }}</a-divider>-->
                  <a-form-item label="固定汇率" v-if="selectedExchangeRate === 1" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                    <a-input-number style="width: 20%" allow-clear v-decorator="['fixed_exchange_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="汇率"/>
                  </a-form-item>
                  <a-row v-if="selectedExchangeRate === 2">
                    <a-col :span="12">
                      <a-form-item label="日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                        <a-date-picker
                          v-decorator="['fixed_date_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                          format="YYYY-MM-DD"
                          value-format="yyyy-MM-DD"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item label="汇率定义方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                        <a-input v-decorator="['exchange_rate_definition', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="汇率定义方式" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-form-item label="其他日期汇率" v-if="selectedExchangeRate === 3" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                    <a-textarea allow-clear v-decorator="['unfixed_date_rate', {rules: [{required: true, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number style="width: 50%" allow-clear v-decorator="['unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="单价"/>
                    <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="单价是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_unit_price', {valuePropName: 'checked', rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="临时汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number style="width: 50%" allow-clear v-decorator="['temp_exchange_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="临时汇率"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number style="width: 50%" allow-clear v-decorator="['pricing_count', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="数量"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number
                      style="width: 50%"
                      allow-clear
                      placeholder="合同金额"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      v-decorator="['contract_amount', { rules: [{required: false, message: '必填项，请填写信息'}]}]" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_contract_amount', {valuePropName: 'checked', rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 3">
              <a-divider orientation="left" dashed>浮动定价</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="PACE指数月份" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-month-picker
                      v-decorator="['pace_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                      placeholder="PACE指数月份"
                      format="YYYY-MM"
                      value-format="yyyy-MM-DD"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="升贴水" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number allow-clear v-decorator="['premium_discount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="升贴水"/>
                    <span style="padding-left: 10px">正数为升水、负数为贴水</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-select
                      v-decorator="[
                        'pricing_currency',
                        {
                          rules: [
                            { required: false, message: '请选择' }
                          ],
                        },
                      ]"
                      placeholder="选择"
                      show-search
                      @change="pricingCurrencyChange"
                      option-filter-prop="children"
                      :filter-option="filterOption">
                      <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input allow-clear v-decorator="['exchange_rate', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number style="width: 50%" allow-clear v-decorator="['pricing_count', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="数量"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number
                      style="width: 50%"
                      allow-clear
                      placeholder="合同金额"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      v-decorator="['contract_amount', { rules: [{required: false, message: '必填项，请填写信息'}]}]" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_contract_amount', {valuePropName: 'checked', rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                付款方式
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="预付款方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-select
                  @change="paymentMethodChange"
                  placeholder="选择"
                  v-decorator="[
                    'payment_method',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ]
                    }
                  ]">
                  <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_pre_payment_method" :key="index">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :offset="2" :span="20" class="hidden_item" v-if="paymentMethod > 0">
              <a-divider orientation="left" dashed>{{ paymentMethodTitle }}</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="预付款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number @change="prePaymentChange" style="width: 25%" allow-clear v-decorator="['pre_payment', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
                    <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.receivedPricingCurrency] }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="预付款支付期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-date-picker
                      v-decorator="['pre_payment_date', {rules: [{required: prePayment > 0, message: '必填项，请填写信息'}]}]"
                      format="YYYY-MM-DD"
                      value-format="yyyy-MM-DD"
                    /> 前
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="24" v-if="false">
              <a-form-item label="尾款方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-select
                  @change="balancePaymentMethodChange"
                  placeholder="选择"
                  v-decorator="[
                    'balance_payment_method',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ]
                    }
                  ]">
                  <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_balance_payment_method" :key="index">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :offset="2" :span="20" class="hidden_item" v-if="balancePaymentMethod > 0 && balancePaymentMethod !== 6 && false">
              <a-divider orientation="left" dashed>{{ balancePaymentMethodTitle }}</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="尾款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number @change="balancePaymentChange" style="width: 25%" allow-clear v-decorator="['balance_payment', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
                    <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="尾款支付期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-select
                      style="width: 80%"
                      v-decorator="[
                        'trade_balance_payment_date_method',
                        {
                          rules: [
                            { required: balancePayment !== 0, message: '请选择' }
                          ],
                        },
                      ]"
                      placeholder="选择"
                      allow-clear
                      @change="tradeBalancePaymentTimeChange"
                      option-filter-prop="children"
                      :filter-option="filterOption">
                      <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_balance_payment_date_method">{{ val }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="tradeBalancePaymentTimeMethod === 1">
                  <a-form-item label="确定尾款日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-date-picker
                      v-decorator="['balance_payment_date', {rules: [{required: tradeBalancePaymentTimeMethod === 1, message: '必填项，请填写信息'}]}]"
                      format="YYYY-MM-DD"
                      placeholder="尾款日期"
                      value-format="yyyy-MM-DD"
                    /> 前
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="tradeBalancePaymentTimeMethod === 2">
                  <a-form-item label="承兑日后" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input-number allow-clear v-decorator="['trade_balance_payment_days', {initialValue: 0, rules: [{required: tradeBalancePaymentTimeMethod === 2, message: '必填项，请填写信息'}]}]"/> （天）
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="tradeBalancePaymentTimeMethod === 3">
                  <a-form-item label="不确定尾款日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    <a-input allow-clear v-decorator="['unbalance_payment_date_desc', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                货转信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="备案仓库" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  :filter-option="false"
                  :not-found-content="warehouseFetching ? undefined : null"
                  show-search
                  allow-clear
                  v-decorator="[
                    'warehouse_id',
                    {
                      rules: [
                        { required: false, message: '选择项目' },
                      ],
                    },
                  ]"
                  placeholder="请输入仓库名称"
                  @search="this.warehouseSearch"
                >
                  <a-spin v-if="warehouseFetching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="d in tradeWarehouseList" :key="d.id">
                    {{ d.name }}（{{ d.location }}）
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="入库货转类型" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-select
                  allow-clear
                  @change="handleStockTransferTypeChange"
                  placeholder="选择"
                  v-decorator="[
                    'warehouse_stock_transfer_type',
                    {
                      rules: [
                        { required: false, message: '请选择' }
                      ]
                    }
                  ]">
                  <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_warehouse_stock_transfer_types" :key="index">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="stockTransferType === 1">
              <a-form-item label="货转前提条件" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  style="width: 50%"
                  allow-clear
                  @change="handlePrerequisityGoodsTransferChange"
                  placeholder="选择"
                  v-decorator="[
                    'goods_transfer_prerequisity',
                    {
                      rules: [
                        { required: false, message: '请选择' }
                      ]
                    }
                  ]">
                  <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_sell_contract_goods_transfer_prerequisites" :key="index">
                    {{ item }}
                  </a-select-option>
                </a-select>
                <a-input-number
                  style="width: 30%"
                  v-if="goodsTransferPrerequisity >= 1"
                  v-decorator="[
                    'postpone_days',
                    {
                      rules: [
                        { required: goodsTransferPrerequisity >= 1, message: '请选择' }
                      ]
                    }
                  ]"
                  placeholder="请输入天数"/>
                <a-select
                  v-decorator="[
                    'postpone_days_type',
                    {
                      rules: [
                        { required: goodsTransferPrerequisity >= 1, message: '请选择' }
                      ]
                    }
                  ]"
                  v-show="goodsTransferPrerequisity >= 1"
                  default-value="2"
                  style="width: 20%"
                  placeholder="选择">
                  <a-select-option value="1">
                    天
                  </a-select-option>
                  <a-select-option value="2">
                    工作日
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="stockTransferType === 2">
              <a-form-item label="货转后约束条件" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input allow-clear v-decorator="['constraints', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="提货期" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-select
                  allow-clear
                  @change="handleDeliveryPeriodTypeChange"
                  placeholder="选择"
                  v-decorator="[
                    'delivery_period_type',
                    {
                      rules: [
                        { required: false, message: '请选择' }
                      ]
                    }
                  ]">
                  <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_delivery_period_types" :key="index">
                    {{ item }}
                  </a-select-option>
                </a-select>
                <a-input-number
                  style="width: 30%"
                  v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0"
                  v-decorator="[
                    'delivery_period_postpone_days',
                    {
                      rules: [
                        { required: deliveryPeriodType !== 6, message: '请选择' }
                      ]
                    }
                  ]"
                  placeholder="请输入超期天数"/>
                <a-select
                  v-decorator="[
                    'delivery_period_postpone_days_type',
                    {
                      rules: [
                        { required: deliveryPeriodType !== 6, message: '请选择' }
                      ]
                    }
                  ]"
                  v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0"
                  default-value="2"
                  style="width: 20%"
                  placeholder="选择">
                  <a-select-option value="1">
                    天
                  </a-select-option>
                  <a-select-option value="2">
                    工作日
                  </a-select-option>
                </a-select>
                <span v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0" style="padding-left: 5px">内提完</span>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0">
              <a-form-item label="超期责任人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-if="false" allow-clear v-decorator="['undertaking_party', {rules: [{required: stockTransferType === 2, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
                <a-select
                  option-label-prop="tt"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  v-decorator="[
                    'undertaking_party_id',
                    {
                      rules: [
                        { required: false, message: '请选择' },
                      ],
                    },
                  ]"
                  placeholder="请输入"
                  :default-active-first-option="false"
                  @search="this.clientSearch"
                >
                  <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                    {{ d.client }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                结算信息
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="结算量" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-select
                  :filter-option="false"
                  :not-found-content="null"
                  allow-clear
                  v-decorator="[
                    'settlement_volume',
                    {
                      rules: [
                        { required: false, message: '请选择' },
                      ],
                    },
                  ]"
                  placeholder="请选择"
                  @change="handleTradeSettlementVolumeChange"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in settlementVolumeList">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="settlementVolumeContent !== undefined && settlementVolumeContent.length > 0">
              <a-form-item label="结算量内容" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-tag v-for="(value, key) in settlementVolumeContent" :key="key" >{{ value }}</a-tag>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="settlementVolumeContent !== undefined && settlementVolumeContent.length === 0 && settlementVolume === 5">
              <a-form-item label="结算量名称" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-input allow-clear v-decorator="['custom_settlement_volume', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="settlementVolumeContent !== undefined && settlementVolumeContent.length === 0">
              <a-form-item label="结算量内容" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-modal :visible="settlementVolumeVisible" @ok="addCustomSettlementVolume" @cancel="settlementVolumeVisible=false" title="添加">
                  <a-input allow-clear placeholder="请输入" v-model="custom_settlement_volume_content"/>
                </a-modal>
                <a-button style="margin-right: 10px" @click="settlementVolumeVisible=true">添加</a-button>
                <a-tag closable @close="deleteCustomSettlementVolumeContent(content.key)" v-for="content in customSettlementVolumeContent" :key="content.key">{{ content.name }}</a-tag>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                附件信息
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="合同附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
                <a-table
                  bordered
                  :data-source="otherData.attachment"
                  :columns="attachmentColumns"
                  v-if="this.otherData.attachment.length > 0"
                  :pagination="false"
                  key="key">
                  <template slot="action" slot-scope="text, record">
                    <a-popconfirm
                      v-if="otherData.attachment.length"
                      title="确定删除?"
                      @confirm="() => onAttachmentDelete(record.key)"
                    >
                      <a href="javascript:;">删除</a>
                    </a-popconfirm>
                  </template>
                </a-table>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <component
          :ref="currentComponent"
          @cancel="handleAddCancel"
          @ok="handleOk"
          :record="mdl"
          :is="currentComponent"
          :visible="visibleFrom"
          v-if="visibleFrom"
          :loading="confirmLoadingFrom"
          :model="mdl"></component>
        <a-row>
          <a-col span="6" :offset="8">
            <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
          </a-col>
          <a-col span="10">
            <a-button @click="handleGoBack">返回</a-button>
          </a-col>
        </a-row>
      </a-spin>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import {
  sell_contract_update,
  sell_contract_list,
  sell_contract_fixed_pricing_list,
  sell_contract_point_pricing_list,
  sell_contract_floating_pricing_list
} from '@/api/trade_sell_contract'
import debounce from 'lodash/debounce'
import { project_client_list } from '@/api/trade_project_client'
import UnitPriceForm from '../modules/UnitPriceForm'
import ExchangeRateForm from '../modules/ExchangeRateForm'
import PaymentMethodForm from '../modules/PaymentMethodForm'
import TurningMonthForm from '../modules/TurningMonthForm'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import CreateProductParameterForm from '../../product_parameter/modules/CreateForm'
import { warehouse_list } from '@/api/trade_warehouse'

const fields = ['number', 'contract_number', 'name', 'trade_type', 'contract_date', 'client_ids', 'product_name',
  'count', 'unit', 'trade_term', 'delivery_address', 'latest_delivery_date', 'overloading_rate', 'shortage_rate', 'tariff', 'tariff_type',
  'consumption_tax', 'consumption_tax_type', 'tax_rate', 'spec', 'customs_declaration_code', 'quality_deduction_reason', 'unit_price_type', 'pricing_currency', 'receive_pricing_currency',
  'unit_price', 'is_tax_unit_price', 'exchange_rate', 'pricing_count', 'contract_amount', 'is_tax_contract_amount',
  'premium_discount', 'price_fixing_fee', 'pricing_source', 'futures_contract', 'lock_up_date', 'pricing_period', 'monthly_transfer_fee',
  'exchange_rate_type', 'fixed_exchange_rate', 'fixed_date_rate', 'exchange_rate_definition', 'unfixed_date_rate', 'temp_exchange_rate',
  'pace_date', 'payment_method', 'pre_payment', 'pre_payment_date', 'balance_payment_method', 'balance_payment',
  'trade_balance_payment_date_method', 'balance_payment_date', 'trade_balance_payment_days', 'warehouse_id',
  'warehouse_stock_transfer_type', 'goods_transfer_prerequisity', 'postpone_days', 'postpone_days_type',
  'constraints', 'delivery_period_type', 'delivery_period_postpone_days', 'delivery_period_postpone_days_type',
  'undertaking_party_id', 'settlement_volume', 'custom_settlement_volume'
]
export default {
  name: 'TableEdit',
  components: {
    UnitPriceForm,
    ExchangeRateForm,
    PaymentMethodForm,
    AttachmentCreateForm,
    TurningMonthForm,
    CreateProductParameterForm
  },
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    this.warehouseSearch = debounce(this.handleWarehouseSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      futuresContractFirstId: 0,
      futuresSellContractFirstId: 0,
      data: {},
      formLayout: 'horizontal',
      mdl: {},
      selectedUnitPrice: 0,
      selectedExchangeRate: 0,
      isSelectedTempUnitPrice: 0, // 是否有临时单价
      isSelectedTempExchangeRate: 0, // 是否有临时汇率
      isSelectedTempContractAmount: 0, // 是否有临时合同金额
      paymentMethod: 0, // 支付方式
      balancePaymentMethod: 0, // 支付方式
      tradeBalancePaymentTimeMethod: 0, // 支付方式
      prePayment: 0, // 预付款
      balancePayment: 0, // 预付款
      pricingCurrency: undefined, // 计价币种
      receivedPricingCurrency: undefined, // 收款币种
      tradeTypes: this.$Dictionaries.trade_types,
      currentComponent: '',
      loading: false,
      visibleFrom: false,
      confirmLoadingFrom: false,
      warehouseFetching: false,
      tradeWarehouseList: [],
      stockTransferType: 0, // 入库货转类型
      goodsTransferPrerequisity: 0, // 货转前提条件
      deliveryPeriodType: 0, // 提货期
      settlementVolume: 0,
      tradeType: -1,
      settlementVolumeList: this.$Dictionaries.trade_settlement_volume,
      settlementVolumeContent: undefined,
      custom_settlement_volume_content: undefined,
      customSettlementVolumeContent: [],
      settlementVolumeVisible: false,
      isTurningMonth: false,
      otherData: {
        key_point: [],
        attachment: [],
        turning_month_list: [],
        product_parameters: []
      },
      clientList: [],
      turningMonthColumns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '转月后期货合约',
          dataIndex: 'futures_contract',
          width: 150,
          align: 'center',
          ellipsis: true,
          customRender: (text) => text.substring(0, text.lastIndexOf('-'))
        },
        {
          title: '转月后默认计价期',
          dataIndex: 'pricing_period_start_date',
          ellipsis: true,
          align: 'center',
          customRender: (text, obj) => text + '~' + obj.pricing_period_end_date
        },
        {
          title: '转月后锁价期限',
          dataIndex: 'lock_up_date',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          width: 100,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 100
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      parameterColumns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true
        },
        {
          title: '符号',
          dataIndex: 'symbol',
          width: 160,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_value_compare_symbol[text] || '无'
        },
        {
          title: '值',
          dataIndex: 'standard_value',
          width: 160,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted () {
    this.loadContract()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    title () {
      if (this.model['type'] === '1') {
        return '新建采购合同'
      } else {
        return '新建销售合同'
      }
    },
    exchangeRateTitle () {
      if (this.selectedExchangeRate === 1) {
        return '汇率-固定汇率'
      } else if (this.selectedExchangeRate === 2) {
        return '汇率-日期'
      } else if (this.selectedExchangeRate === 3) {
        return '汇率-其他日期汇率'
      }
      return ''
    },
    paymentMethodTitle () {
      if (this.paymentMethod > 0) {
        return '预付款支付-' + (this.$Dictionaries.trade_pre_payment_method[this.paymentMethod] || '')
      }
      return ''
    },
    balancePaymentMethodTitle () {
      if (this.balancePaymentMethod > 0) {
        return '尾款支付-' + (this.$Dictionaries.trade_balance_payment_method[this.paymentMethod] || '')
      }
      return ''
    },
    balancePaymentMethodKeys () {
      return Object.keys(this.$Dictionaries.trade_balance_payment_method).map(item => Number(item))
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadContract () {
      this.loading = true
      sell_contract_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.loadTransferInfo(this.data)
            this.loadSettlementInfo(this.data)
            // this.loadEditInfo(this.data)
            this.handleClientSearch(undefined)
            this.loadPricingByType(this.data)
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 3000)
      })
    },
    loadTransferInfo (data) {
      // 货转信息
      const transferInfo = data.transfer_info
      if (transferInfo.warehouse_stock_transfer_type === 3) {
        transferInfo.warehouse_stock_transfer_type = undefined
      }
      this.stockTransferType = transferInfo.warehouse_stock_transfer_type
      if (this.stockTransferType === 1) {
        this.goodsTransferPrerequisity = transferInfo.goods_transfer_prerequisity
      }
      this.data.warehouse_id = transferInfo.warehouse_id
      if (transferInfo.warehouse_stock_transfer_type) {
        this.data.warehouse_stock_transfer_type = transferInfo.warehouse_stock_transfer_type + ''
      }
      this.data.goods_transfer_prerequisity = transferInfo.goods_transfer_prerequisity + ''
      if (transferInfo.delivery_period_type) {
        this.data.delivery_period_type = transferInfo.delivery_period_type + ''
        this.deliveryPeriodType = transferInfo.delivery_period_type
        this.data.delivery_period_postpone_days = transferInfo.delivery_period_postpone_days
        this.data.delivery_period_postpone_days_type = transferInfo.delivery_period_postpone_days_type + ''
        this.data.undertaking_party_id = transferInfo.undertaking_party_id
      }
      this.data.postpone_days = transferInfo.postpone_days
      this.data.postpone_days_type = transferInfo.postpone_days_type + ''
      this.data.constraints = transferInfo.constraints
      this.loadWarehouseData({ id: transferInfo.warehouse_id })
    },
    loadSettlementInfo (data) {
      const settlementInfo = data.settlement_info
      if ([1, 2, 3, 4, 5].includes(settlementInfo.settlement_volume)) {
        this.data.settlement_volume = settlementInfo.settlement_volume + ''
      }
      this.handleTradeSettlementVolumeChange(settlementInfo.settlement_volume)
      if (settlementInfo.settlement_volume === 5) {
        this.data.custom_settlement_volume = settlementInfo.custom_settlement_volume.length > 0 ? settlementInfo.custom_settlement_volume : undefined
      }
    },
    setPricingData (pricingData) {
      this.data = { ...this.data, ...pricingData }
      this.loadEditInfo(this.data)
    },
    loadPricingByType (data) {
      const parameter = { sell_contract_id: data.id, unit_price_type: data.unit_price_type }
      if (data.unit_price_type === 1) {
        sell_contract_fixed_pricing_list(parameter).then(res => {
          if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
            this.setPricingData(res.data.entries[0])
          } else {
            this.loadEditInfo(data)
          }
        })
      } else if (data.unit_price_type === 2) {
        sell_contract_point_pricing_list(parameter).then(res => {
          if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
            this.setPricingData(res.data.entries[0])
          } else {
            this.loadEditInfo(data)
          }
        })
      } else if (data.unit_price_type === 3) {
        sell_contract_floating_pricing_list(parameter).then(res => {
          if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
            this.setPricingData(res.data.entries[0])
          } else {
            this.loadEditInfo(data)
          }
        })
      } else {
        this.loadEditInfo(data)
      }
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.data.project_id }).then((res) => {
        const result = res.data.entries || []
        this.clientList = result
      })
    },
    handleWarehouseSearch (value) {
      this.loadWarehouseData({ name: value })
    },
    loadWarehouseData (params) {
      this.warehouseFetching = true
      this.tradeWarehouseList = []
      warehouse_list(params).then((res) => {
        this.tradeWarehouseList = res.data.entries || []
      }).finally(() => {
        this.warehouseFetching = false
      })
    },
    handleStockTransferTypeChange (v) {
      if (v !== undefined) {
        this.stockTransferType = Number(v)
      } else {
        this.stockTransferType = 0
      }
    },
    handlePrerequisityGoodsTransferChange (v) {
      if (v !== undefined) {
        this.goodsTransferPrerequisity = Number(v)
      } else {
        this.goodsTransferPrerequisity = 0
      }
    },
    handleTradeSettlementVolumeChange (v) {
      const key = Number(v)
      this.settlementVolume = key
      const tradeSettlementVolumeContent = { 1: '毛重, 净重, 毛桶, 净桶', 2: '毛重, 净重, 毛桶, 净桶', 3: '毛重, 净重, 毛桶, 净桶', 4: '毛重, 净重' }
      if (key in tradeSettlementVolumeContent) {
        this.settlementVolumeContent = tradeSettlementVolumeContent[key].split(',')
        this.customSettlementVolumeContent = []
      } else {
        this.settlementVolumeContent = []
        this.customSettlementVolumeContent = []
      }
    },
    handleDeliveryPeriodTypeChange (v) {
      if (v !== undefined) {
        this.deliveryPeriodType = Number(v)
      } else {
        this.deliveryPeriodType = 0
      }
    },
    addCustomSettlementVolume () {
      if (this.custom_settlement_volume_content !== undefined && this.customSettlementVolumeContent !== '') {
        const exists = this.customSettlementVolumeContent.some(item => item.name === this.custom_settlement_volume_content)
        if (exists) {
          this.$message.warning('内容重复')
          return
        }
        this.customSettlementVolumeContent.push({
          name: this.custom_settlement_volume_content,
          key: this.randomNumber()
        })
        this.custom_settlement_volume_content = undefined
        this.settlementVolumeVisible = false
      } else {
        this.$message.warning('输入内容')
      }
    },
    deleteCustomSettlementVolumeContent (key) {
      this.customSettlementVolumeContent = this.customSettlementVolumeContent.filter(item => item.key !== key)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAddAttachment () {
      this.currentComponent = 'AttachmentCreateForm'
      this.visibleFrom = true
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          const otherDataInfo = this.otherData
          if (values['unit_price'] === null) {
            values['unit_price'] = undefined
          }
          if (values['contract_date'] === null) {
            values['contract_date'] = '1970-01-01'
          }
          if (this.tradeType === 1) {
            values['trade_term'] = ''
            values['customs_declaration_code'] = ''
          }
          const { values_new } = this.unitPriceValues(values, otherDataInfo)
          values['attachment'] = this.otherData.attachment
          values.product_parameters = this.otherData.product_parameters.map(item => {
            delete item['key']
            return item
          })
          const final_values = { ...values_new }
          // 结算信息
          if (this.settlementVolumeContent !== undefined && this.settlementVolumeContent.length > 0) {
            final_values['settlement_volume_content'] = this.settlementVolumeContent.map(name => ({
              name: name
            }))
          } else if (this.customSettlementVolumeContent !== undefined && this.customSettlementVolumeContent.length > 0) {
            final_values['settlement_volume_content'] = this.customSettlementVolumeContent
          }
          this.loading = true
          sell_contract_update(final_values, this.$route.params.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
              } else {
                this.handleGoBack()
              }
            }).finally(() => {
              this.loading = false
          })
        }
      })
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    tradeBalancePaymentTimeChange (v) {
      if (v !== undefined) {
        this.tradeBalancePaymentTimeMethod = Number(v)
      } else {
        this.tradeBalancePaymentTimeMethod = 0
      }
    },
    loadFormData (data) {
      this.selectedUnitPrice = data.unit_price_type
      this.selectedExchangeRate = data.exchange_rate_type
      this.tradeType = data.trade_type
      if (this.tradeType === 1) {
        data.trade_term = ''
        data.customs_declaration_code = ''
      }
      this.paymentMethod = data.payment_method
      if (this.balancePaymentMethodKeys.includes(data.balance_payment_method)) {
        this.balancePaymentMethod = data.balance_payment_method
      }
      this.tradeBalancePaymentTimeMethod = data.trade_balance_payment_date_method
      this.settlementVolume = data.settlement_info.settlement_volume
      if (data.settlement_info.settlement_volume === 5) {
        this.settlementVolumeContent = []
        this.customSettlementVolumeContent = data.settlement_info.settlement_volume_content !== undefined &&
        data.settlement_info.settlement_volume_content !== '' ? data.settlement_info.settlement_volume_content.split(',') : undefined
        if (this.customSettlementVolumeContent) {
          this.customSettlementVolumeContent = this.customSettlementVolumeContent.map(item => {
            const content = {
              name: item,
              key: this.randomNumber()
            }
            return content
          })
        }
      } else {
        this.customSettlementVolumeContent = []
        this.settlementVolumeContent = data.settlement_info.settlement_volume_content !== undefined ? data.settlement_info.settlement_volume_content.split(',') : ''
      }
      this.isTurningMonth = data.unit_price_type === 2 && data['futures_contract_list'] !== undefined && data['futures_contract_list'].length > 1
      this.pricingCurrency = data.pricing_currency
      this.receivedPricingCurrency = data.receive_pricing_currency
      this.prePayment = data.pre_payment
      this.balancePayment = data.balance_payment
      this.otherData.product_parameters = data.product_parameter_list
      if (data.tariff_type === 0) {
        data.tariff_type = undefined
      } else {
        data.tariff_type = '' + data.tariff_type
      }

      if (data.consumption_tax_type === 0) {
        data.consumption_tax_type = undefined
      } else {
        data.consumption_tax_type = '' + data.consumption_tax_type
      }
    },
    normalizeDate (date_str) {
      if (date_str === '1970-01-01' || date_str === '' || date_str === null) {
        return undefined
      }
      return date_str
    },
    normalizeFormData (formData, data) {
      if (formData.pricing_currency !== undefined && formData.pricing_currency !== null && formData.pricing_currency !== 'null') {
        formData.pricing_currency = '' + formData.pricing_currency
      }
      if (formData.pricing_currency !== undefined && formData.pricing_currency !== null && formData.pricing_currency !== 'null') {
        formData.receive_pricing_currency = '' + formData.receive_pricing_currency
      }
      formData.trade_type = '' + data.trade_type
      formData.unit_price_type = '' + data.unit_price_type
      if (formData.exchange_rate !== undefined && formData.exchange_rate !== null && formData.exchange_rate !== 'null') {
        formData.exchange_rate = '' + formData.exchange_rate
      }
      if (formData.exchange_rate_type !== undefined && formData.exchange_rate_type !== null && formData.exchange_rate_type !== 'null') {
        formData.exchange_rate_type = '' + formData.exchange_rate_type
      }
      formData.payment_method = '' + formData.payment_method
      if (this.balancePaymentMethodKeys.includes(data.balance_payment_method)) {
        formData.balance_payment_method = '' + data.balance_payment_method
      } else {
        formData.balance_payment_method = undefined
      }
      formData.trade_balance_payment_date_method = '' + formData.trade_balance_payment_date_method
      if (formData.unit_price_type === '2' && data['futures_contract_list'] !== undefined && data['futures_contract_list'].length > 0) {
        formData.pricing_period = [ moment(data['futures_contract_list'][0]['pricing_period_start_date']),
          moment(data['futures_contract_list'][0]['pricing_period_end_date']) ]
        formData.futures_contract = data['futures_contract_list'][0]['futures_contract']
        formData.lock_up_date = data['futures_contract_list'][0]['lock_up_date']
        this.futuresContractFirstId = data['futures_contract_list'][0]['id']
        this.futuresSellContractFirstId = data['futures_contract_list'][0]['sell_contract_id']
      }
      return formData
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      this.loadFormData(data)
      data.contract_date = this.normalizeDate(data.contract_date)
      data.pre_payment_date = this.normalizeDate(data.pre_payment_date)
      data.latest_delivery_date = this.normalizeDate(data.latest_delivery_date)
      this.prePayment = data.pre_payment
      console.log('========', this.prePayment)
      const values = { turning_month_list: data['futures_contract_list'] }
      this.setUnitPriceData(data.unit_price_type, values)
      new Promise((resolve) => {
        setTimeout(resolve, 10)
      }).then(() => {
        let formData = pick(data, fields)
        formData = this.normalizeFormData(formData, data)
        form.setFieldsValue(formData)
      })
    },
    unitPriceValues (values, data) {
      // 单价
      const values_new = { ...values, ...data }
      if (values) {
        if (values['unit_price_type'] === '2') {
          const turning_month_list = []
          const start_date = values['pricing_period'][0].format('YYYY-MM-DD')
          const end_date = values['pricing_period'][1].format('YYYY-MM-DD')
          const futures_contract = values['futures_contract']
          const lock_up_date = values['lock_up_date']
          turning_month_list.push({
            futures_contract: futures_contract,
            lock_up_date: lock_up_date,
            pricing_period_start_date: start_date,
            pricing_period_end_date: end_date,
            id: this.futuresContractFirstId,
            sell_contract_id: this.futuresSellContractFirstId
          })
          values_new['futures_contract'] = undefined
          values_new['lock_up_date'] = undefined
          values_new['pricing_period'] = undefined
          if (data.turning_month_list.length > 0) {
            const data_list = data.turning_month_list.map(item => {
              item['key'] = undefined
              return item
            })
            turning_month_list.push(...data_list)
          }
          const ids = []
          const turning_month_list_new = []
          for (let i = 0; i < turning_month_list.length; i++) {
            if (turning_month_list[i]['id'] !== undefined) {
              if (!(turning_month_list[i]['id'] in ids)) {
                ids.push(turning_month_list[i]['id'])
                turning_month_list_new.push(turning_month_list[i])
              }
            } else {
              turning_month_list_new.push(turning_month_list[i])
            }
          }
          values_new['turning_month_list'] = turning_month_list_new
        }
      }
      return {
        values_new: values_new
      }
    },
    setUnitPriceData (index, values) {
      this.selectedUnitPrice = index
      if (values !== undefined) {
        if (index === 2 && values['turning_month_list'] !== undefined) {
          this.otherData.turning_month_list = values['turning_month_list'].filter((item, index, arr) => {
            if (index > 0) {
              item['key'] = this.randomNumber()
              return true
            }
            return false
          })
        }
      }
    },
    randomNumber () {
      const current_date = new Date()
      const random = Math.floor(Math.random() * 100000)
      return current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + '' + random
    },
    handleAddCancel () {
      this.visibleFrom = false
      this.mdl = {}
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    addTurningMonth (v) {
      if (!v) {
        this.otherData.turning_month_list = []
      }
      this.currentComponent = 'TurningMonthForm'
      this.mdl['size'] = this.otherData.turning_month_list.length
      this.visibleFrom = v
    },
    onDeleteItem (key) {
      const dataSource = [...this.otherData.turning_month_list]
      this.otherData.turning_month_list = dataSource.filter(item => item.key !== key)
      if (this.otherData.turning_month_list.length === 0) {
        this.form.setFieldsValue({ is_turning_month: false })
      }
    },
    handleOk (data) {
      const form = this.$refs[this.currentComponent].form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, data)
          // 新增
          if (this.currentComponent === 'KeyPointCreateForm') {
            values.keys = this.randomNumber()
            this.otherData.key_point.push(values)
          } else if (this.currentComponent === 'AttachmentCreateForm') {
            values.url = values.url.fileList[0].url
            values.key = this.randomNumber()
            this.otherData.attachment.push(values)
          } else if (this.currentComponent === 'TurningMonthForm') {
            const start_date = values['pricing_period'][0].format('YYYY-MM-DD')
            const end_date = values['pricing_period'][1].format('YYYY-MM-DD')
            values['pricing_period'] = undefined
            values['pricing_period_start_date'] = start_date
            values['pricing_period_end_date'] = end_date
            values.key = this.randomNumber()
            this.otherData.turning_month_list.push(values)
            form.resetFields()
          } else if (this.currentComponent === 'CreateProductParameterForm') {
            this.otherData.product_parameters = this.composeData(data, this.otherData.product_parameters)
          }
          this.visibleFrom = false
          form.resetFields()
        } else {
          this.confirmLoading = false
        }
      })
    },
    composeData (newList, oldList) {
      if (oldList === undefined || oldList.length === 0) {
        return newList
      } else {
        const seen = new Set()
        newList.forEach(item => {
          if (item.name) {
            seen.add(item.name)
          }
        })
        const filteredOldList = oldList.filter(item => item.name && !seen.has(item.name))
        return [...filteredOldList, ...newList]
      }
    },
    unitPriceChange (v) {
      if (v !== undefined) {
        this.selectedUnitPrice = Number(v)
      } else {
        this.selectedUnitPrice = 0
      }
      this.otherData.turning_month_list = []
      this.form.setFieldsValue({ is_turning_month: false })
    },
    handleTurningMonthChange (v) {
      this.isTurningMonth = v
    },
    exchangeRateChange (v) {
      if (v !== undefined) {
        this.selectedExchangeRate = Number(v)
      } else {
        this.selectedExchangeRate = 0
      }
    },
    isTempUnitPriceChange (v) {
      if (v !== undefined) {
        this.isSelectedTempUnitPrice = Number(v)
      } else {
        this.isSelectedTempUnitPrice = 0
      }
    },
    isTempExchangeRateChange (v) {
      if (v !== undefined) {
        this.isSelectedTempExchangeRate = Number(v)
      } else {
        this.isSelectedTempExchangeRate = 0
      }
    },
    paymentMethodChange (v) {
      if (v !== undefined) {
        this.paymentMethod = Number(v)
      } else {
        this.paymentMethod = 0
      }
    },
    isTempContractAmountChange (v) {
      if (v !== undefined) {
        this.isSelectedTempContractAmount = Number(v)
      } else {
        this.isSelectedTempContractAmount = 0
      }
    },
    balancePaymentMethodChange (v) {
      if (v !== undefined) {
        this.balancePaymentMethod = Number(v)
      } else {
        this.balancePaymentMethod = 6
      }
    },
    time (dates, dateStrings) {
      // this.param.start_date = dateStrings[0]
      // this.param.end_date = dateStrings[1]
    },
    productNameChange (e) {
      const new_product_name = e.target.value
      if (new_product_name !== this.data.product_name) {
        this.otherData.product_parameters = []
      } else {
        this.otherData.product_parameters = this.data.product_parameter_list
      }
    },
    addProductParameter (product_parameter_list) {
      // this.$router.push({ path: '/trade/' + record.id + '/product_parameter', query: { name: record.name } })
      this.currentComponent = 'CreateProductParameterForm'
      const product_name = this.form.getFieldValue('product_name')
      if (product_name !== this.data.product_name) {
        this.mdl['product_parameter_list'] = this.otherData.product_parameters
      } else {
        this.mdl['product_parameter_list'] = product_parameter_list
      }
      this.mdl['name'] = product_name
      this.visibleFrom = true
    },
    onParameterDelete (id) {
      this.otherData.product_parameters = this.otherData.product_parameters.filter(product => {
        return product.id !== id
      })
    },
    prePaymentChange (value) {
      this.prePayment = value
    },
    balancePaymentChange (value) {
      this.balancePayment = value
    },
    pricingCurrencyChange (value) {
      this.pricingCurrency = value
    },
    receivedPricingCurrencyChange (value) {
      this.receivedPricingCurrency = value
    },
    handleTradeTypeChange (value) {
      if (value !== undefined) {
        this.tradeType = Number(value)
        if (this.tradeType !== 1) {
          // 贸易代码和报关术语清空
          this.form.setFieldsValue({
            trade_term: ' '
          })
          this.form.setFieldsValue({
            customs_declaration_code: ' '
          })
        }
      } else {
        this.tradeType = -1
      }
    }
  }
}
</script>
<style scoped>
.hidden_item {
  border: 1px solid #eeeeee;
  background-color: #efefef6a;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
</style>
